import React from 'react';
import { motion } from 'framer-motion';
import '../styles/partners.css';
import PartnerData from '../data/PartnerData';

function Partners() {
  return (
    <motion.div 
      className="partners"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <p>Featured Clients</p>
      
      <motion.div 
        className="logo-container"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { staggerChildren: 0.3 }, // Staggered animation for logos
          },
        }}
      >
        {PartnerData.map((partner, index) => (
          <motion.div
            className="partner-logo"
            key={index}
            whileHover={{ scale: 1.1 }} // Hover effect
            variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } }}
            transition={{ duration: 0.5 }}
          >
            <img src={partner.image} alt={partner.name} />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}

export default Partners;
